/**
 * Query key factory for wishlist queries
 * Enables granular cache invalidation and consistent key structure
 */
export const wishlistKeys = {
  all: ['wishlist'] as const,

  /** The user's wishlist metadata + entries */
  list: () => [...wishlistKeys.all, 'list'] as const,

  /** Resolved products (full OrderLine data) */
  products: () => [...wishlistKeys.all, 'products'] as const,
};
